<div class="modal-header">
  <h5 class="modal-title">{{ isEditMode ? 'แก้ไขข้อมูลรหัสมาตรฐานสินค้า' : 'เพิ่มข้อมูลรหัสมาตรฐานสินค้า' }}</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body" [class.view-only-form]="viewOnly">
  <form [formGroup]="form">
    <div class="row mb-3">
      <div class="col-sm-4"><label for="title" class="form-label mb-0 required">ชื่อมาตรฐานสินค้าเกษตร</label></div>
      <div class="col-sm-8"><input class="form-control form-control-sm" id="title" formControlName="title"></div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="shortStandard" class="form-label mb-0">ชื่อย่อมาตรฐานสินค้าเกษตร</label></div>
      <div class="col-sm-8"><input class="form-control form-control-sm" formControlName="shortStandard" id="shortStandard"></div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="standardtype" class="form-label mb-0 required">หมวดรหัสมาตรฐานสินค้าเกษตร</label></div>
      <div class="col-sm-8">
        <select class="form-select form-select-sm" id="standardtype" formControlName="standardType"
                [compareWith]="compareByNumericValue">
          <option [ngValue]="null">กรุณาเลือก</option>
          @for (type of standardTypeOptions; track type.id) {
            <option [ngValue]="type.id">{{ type.title }}</option>
          }
        </select>
        @if (isStandardTypeLoading) {
          <div class="form-text">กำลังโหลดข้อมูลหมวดมาตรฐาน...</div>
        }
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label class="form-label mb-0 required">รหัสมาตรฐานสินค้าเกษตร</label></div>
      <div class="col-sm-8">
        <div class="d-flex gap-2">
          <input class="form-control form-control-sm flex-shrink-0" style="max-width: 100px;"
                 formControlName="preCode" placeholder="คำนำหน้า">
          <input class="form-control form-control-sm" formControlName="standardCode" placeholder="รหัสมาตรฐาน">
        </div>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="enforce" class="form-label mb-0 required">มาตรฐาน</label></div>
      <div class="col-sm-8">
        <select class="form-select form-select-sm" id="enforce" formControlName="enforce">
          <option value="">กรุณาเลือก</option>
          <option value="0">สมัครใจ</option>
          <option value="1">บังคับ</option>
        </select>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label for="state" class="form-label mb-0">สถานะ</label></div>
      <div class="col-sm-8">
        <select class="form-select form-select-sm" id="state" formControlName="state">
          <option [ngValue]="1">เผยแพร่</option>
          <option [ngValue]="0">ไม่เผยแพร่</option>
        </select>
      </div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label class="form-label mb-0">ออกใบรับรองมาตรฐานไม่เกินวันที่</label></div>
      <div class="col-sm-8"><gt-ng-datepicker formControlName="startdate" id="startdate" size="sm"></gt-ng-datepicker></div>
    </div>
    <div class="row mb-3">
      <div class="col-sm-4"><label class="form-label mb-0">วันที่สิ้นสุดใช้งานมาตรฐาน</label></div>
      <div class="col-sm-8"><gt-ng-datepicker formControlName="canceledDate" id="canceledDate" size="sm"></gt-ng-datepicker></div>
    </div>

    @if (isEditMode) {
      <div class="row mb-3">
        <div class="col-sm-4"><label for="recordedBy" class="form-label mb-0">ผู้บันทึก</label></div>
        <div class="col-sm-8"><input id="recordedBy" class="form-control form-control-sm" [value]="recordedByDisplay" readonly></div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-4"><label for="recordedAt" class="form-label mb-0">วันที่บันทึก</label></div>
        <div class="col-sm-8"><input id="recordedAt" class="form-control form-control-sm" [value]="recordedAtDisplay" readonly></div>
      </div>
    }
  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-link btn-sm" (click)="activeModal.close()">ยกเลิก</button>
  @if (!viewOnly) {
    <button type="button" class="btn btn-primary btn-sm btn-custom" (click)="save()" [disabled]="isSubmitting">บันทึก</button>
  }
</div>
